import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea } from '@chakra-ui/react'
import { useState } from 'react'
import { MdOutlineCheck } from 'react-icons/md'
import { NivelColaborador } from '../../../../interfaces'

interface iPropsModalExcluirCommpetencia {
  isOpen: boolean
  onClose: () => void
  excluirCompentencia: (
    nivel: NivelColaborador,
    nomeNivel: string,
    i: number,
    motivoExclusao: string
  ) => void
  indiceDoExcluido: number
  nivel: NivelColaborador
  nivelNome: string
}

export const ModalExcluirAtribuicao: React.FC<iPropsModalExcluirCommpetencia> = ({
  isOpen,
  onClose,
  excluirCompentencia,
  indiceDoExcluido,
  nivel,
  nivelNome
}) => {
  const [motivoExclusao, setMotivoExclusao] = useState('')

  function cancelar(): void {
    setMotivoExclusao('')
    onClose()
  }

  function confirmarExclusao(): void {
    excluirCompentencia(
      nivel,
      nivelNome,
      indiceDoExcluido,
      motivoExclusao
    )

    setMotivoExclusao('')
  }

  return (
    <Modal isOpen={isOpen} onClose={cancelar} isCentered autoFocus={false}>
      <ModalOverlay />

      <ModalContent maxW="900px">
        <ModalHeader fontWeight="bold">
          Escreva o motivo da exclusão do item
        </ModalHeader>

        <ModalCloseButton color="gray.500" bgColor="white" />

        <ModalBody display="flex" justifyContent="center">
          <Flex flexDirection="column" w="100%">
            <Textarea
              w="100%"
              value={motivoExclusao}
              onChange={(e) => setMotivoExclusao(e.target.value)}
            />
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="gray.500"
            p="1.5rem"
            mr={3}
            onClick={cancelar}
          >
            Cancelar
          </Button>

          <Button
            onClick={confirmarExclusao}
            bgColor="green.400"
            p="1.5rem"
            leftIcon={<MdOutlineCheck size={20} />}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
